export default {
  methods: {
    showLoading () {
      // Init loading show
      this.$q.loading.show({
        delay: 2000 // ms
      });
    },
    hideLoading () {
      // Hide loading
      this.$q.loading.hide();
    }
  }
};
